import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Dropdown/dropdown';
import { DropdownContext } from './dropdownConstants';
import { DropdownWithContext } from './DropdownWithContext';
import { useOUIAId } from '../../helpers';
export var Dropdown = function Dropdown(_a) {
  var _onSelect = _a.onSelect,
      ref = _a.ref,
      ouiaId = _a.ouiaId,
      ouiaSafe = _a.ouiaSafe,
      alignments = _a.alignments,
      contextProps = _a.contextProps,
      _a$menuAppendTo = _a.menuAppendTo,
      menuAppendTo = _a$menuAppendTo === void 0 ? 'inline' : _a$menuAppendTo,
      _a$isFlipEnabled = _a.isFlipEnabled,
      isFlipEnabled = _a$isFlipEnabled === void 0 ? false : _a$isFlipEnabled,
      props = __rest(_a, ["onSelect", "ref", "ouiaId", "ouiaSafe", "alignments", "contextProps", "menuAppendTo", "isFlipEnabled"]);

  return React.createElement(DropdownContext.Provider, {
    value: Object.assign({
      onSelect: function onSelect(event) {
        return _onSelect && _onSelect(event);
      },
      toggleTextClass: styles.dropdownToggleText,
      toggleIconClass: styles.dropdownToggleImage,
      toggleIndicatorClass: styles.dropdownToggleIcon,
      menuClass: styles.dropdownMenu,
      itemClass: styles.dropdownMenuItem,
      toggleClass: styles.dropdownToggle,
      baseClass: styles.dropdown,
      baseComponent: 'div',
      sectionClass: styles.dropdownGroup,
      sectionTitleClass: styles.dropdownGroupTitle,
      sectionComponent: 'section',
      disabledClass: styles.modifiers.disabled,
      plainTextClass: styles.modifiers.text,
      ouiaId: useOUIAId(Dropdown.displayName, ouiaId),
      ouiaSafe: ouiaSafe,
      ouiaComponentType: Dropdown.displayName,
      alignments: alignments
    }, contextProps)
  }, React.createElement(DropdownWithContext, Object.assign({
    menuAppendTo: menuAppendTo,
    isFlipEnabled: isFlipEnabled
  }, props)));
};
Dropdown.displayName = 'Dropdown';